import {
  DocumentListCard,
  Field,
  YesObject
} from '@yes.technology/react-toolkit'
import RelationClass from '../RelationClass/RelationClass'
import { RelationConfigProps } from '../types/object-view'
import useRelationClasses from './useRelationClasses/useRelationClasses'

type RelationClassesProps = {
  relationFields: Field[]
  fieldValues: YesObject | undefined
  relationConfig?: RelationConfigProps
  informational?: boolean
  onChange: (fieldColumn: string, value: YesObject[string]) => void
  save: () => Promise<void>
  changeAndSave: (
    fieldColumn: string,
    value: YesObject[string]
  ) => Promise<void>
}

const RelationClasses = ({
  relationFields,
  fieldValues,
  relationConfig,
  informational,
  onChange,
  save,
  changeAndSave
}: RelationClassesProps) => {
  const relationClasses = useRelationClasses({ relationFields, relationConfig })

  return (
    <div className='row row-gap-4'>
      {relationClasses.map((relationField: Field, index) => {
        return (
          <div
            key={`${relationField.relation_objectclass_uuid}-${index}`}
            className={`${relationConfig?.[relationField.uuid]?.column || 'col-lg-6'}`}
          >
            <DocumentListCard style={{ padding: 0 }}>
              <RelationClass
                relationFieldRelation={relationField.relation}
                fieldValues={fieldValues}
                hierarchyLevel={
                  relationConfig?.[relationField.uuid]?.hierarchy_level ||
                  'level_3'
                }
                actionButton={
                  relationConfig?.[relationField.uuid]?.action_button
                }
                layoutClassificationUuid={
                  relationConfig?.[relationField.uuid]
                    ?.uuid_layout_classification
                }
                field={relationField}
                informational={informational}
                navigationSliderBackgroundColor={
                  relationConfig?.[relationField.uuid]
                    ?.navigationslider_background_color || '#DDE5ED'
                }
                navigationSliderColor={
                  relationConfig?.[relationField.uuid]
                    ?.navigationslider_color || '#303032'
                }
                fieldSettings={
                  relationConfig?.[relationField.uuid]?.field_settings
                }
                onChange={onChange}
                save={save}
                changeAndSave={changeAndSave}
              />
            </DocumentListCard>
          </div>
        )
      })}
    </div>
  )
}

export default RelationClasses
